// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".character-prev-value[data-v-27a1b164] {\n  color: #ff5722;\n}\n[data-v-27a1b164] .dx-master-detail-cell {\n  padding: 1px !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
